import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faWhatsapp, faTelegram, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { LoadingGeminiState, EmptyState } from './LoadingGeminiStates';
import './Popups.css';
import AnimatedTrendingList from './AnimatedTrendingList';

export const TrendingPopup = ({ isOpen, onCloseTrending, formattedDate, formattedTime, trending, loadingTrending }) => {
    if (!isOpen) return null;

    const handleShare = (platform) => {
        const trendingText = trending.map((item) => item.title).join("\n");
        const shareText = `Hasil Berita Terhangat ${formattedDate} ${formattedTime}:\n${trendingText} \n\nDibagikan melalui: Selidik | ${decodeURIComponent(window.location.href)}`;
        const encodedText = encodeURIComponent(shareText);

        switch (platform) {
            case 'whatsapp':
                window.open(`https://api.whatsapp.com/send?text=${encodedText}`, '_blank');
                break;
            case 'twitter':
                window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
                break;
            case 'facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${encodedText}`, '_blank');
                break;
            case 'telegram':
                window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodedText}`, '_blank');
                break;
            case 'email':
                window.open(`mailto:?subject=Hasil Analisis Berita&body=${encodedText}`, '_blank');
                break;
            default:
                break;
        }
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <div className="popup-header">
                    <h2>Berita Terhangat</h2>
                    <button className="close-button" onClick={onCloseTrending}>Tutup</button>
                </div>
                <div className="popup-body">
                    {loadingTrending ? (
                        <LoadingGeminiState />
                    ) : trending.length === 0 ? (
                        <EmptyState />
                    ) : (
                        <div>
                            <ul>
                                <AnimatedTrendingList trending={trending} delay={100} />
                                {/* {trending.map((item) => (
                                    <li key={item.id}>
                                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                                            {item.title}
                                        </a>
                                    </li>
                                ))} */}
                            </ul>
                            <p className="timestamp"><strong>🕒 Diperbarui:</strong> {formattedDate} | {formattedTime}</p>
                            <div className="share-buttons">
                                <button onClick={() => handleShare('whatsapp')} className="whatsapp">
                                    <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                                </button>
                                <button onClick={() => handleShare('twitter')} className="twitter">
                                    <FontAwesomeIcon icon={faXTwitter} /> X
                                </button>
                                <button onClick={() => handleShare('facebook')} className="facebook">
                                    <FontAwesomeIcon icon={faFacebook} /> Facebook
                                </button>
                                <button onClick={() => handleShare('telegram')} className="telegram">
                                    <FontAwesomeIcon icon={faTelegram} /> Telegram
                                </button>
                                <button onClick={() => handleShare('email')} className="email">
                                    <FontAwesomeIcon icon={faEnvelope} /> Email
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TrendingPopup;